import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AllAffiliates = lazy(() => import('@pages/producer/AllAffiliates'));

export const AllProducerAffiliatesRoutes: RouteObject[] = [
  {
    path: '/all-affiliates',
    element: (
      <React.Suspense>
        <AllAffiliates />
      </React.Suspense>
    ),
  },
];